import type { TransitionTable } from '../utils/StateMachine';

export const GameState = {
  Boot: 'BOOT',
  Loading: 'LOADING',
  Ready: 'READY',
  Running: 'RUNNING',
  Paused: 'PAUSED',
  GameOver: 'GAME_OVER',
} as const;
export type GameState = (typeof GameState)[keyof typeof GameState];

export const GAME_STATE_TRANSITIONS: TransitionTable<GameState> = {
  BOOT: ['LOADING'],
  LOADING: ['READY'],
  READY: ['RUNNING'],
  RUNNING: ['PAUSED', 'GAME_OVER', 'READY'],
  PAUSED: ['RUNNING', 'READY'],
  GAME_OVER: ['READY', 'RUNNING'],
};
